import styled from "styled-components";

export const ProjectResourcesStyled = styled.div`
  background-color: #f6f6fe !important;

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .table-wrap {
    table {
      background-color: #f6f6fe !important;

      .MuiTableCell-root {
        border: none !important;
      }
      thead {
        tr {
          background-color: #f6f6fe !important;

          th {
            background-color: #f6f6fe !important;
            /* padding: 0 !important; */

            .table-title {
              color: #080425 !important;
            }
          }
        }
      }
      /* tbody {
        tr {
          padding: 8px 16px;
          td {
            padding: 0 !important;
          }
        }
      } */
    }
    .no-data {
      display: flex;
      flex-direction: column;
      gap: 15px;
      justify-content: center;
      align-items: center;
      border: none;
      .content {
        width: 300px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
      }
    }
    .role-data {
      display: flex;
      align-items: center;
      gap: 5px;
      .MuiInputBase-root {
        background-color: transparent !important;
      }
      fieldset {
        border: none !important;
      }
      .MuiOutlinedInput-input {
        padding: 0 !important;
      }
    }

    .collapse {
      .content {
        border: none !important;
        align-items: start;
        padding: 0 !important ;
      }
    }
  }

  .add-btn {
    display: flex;
    flex-direction: ${({ isCollapsed }) =>
      !isCollapsed ? "row-reverse" : "row"};
    padding-top: 24px;
    button {
      width: 100px;
    }
  }
  .icon-btn {
    cursor: pointer;
  }

  .noEvent {
    .MuiInputBase-root {
      pointer-events: none;
    }
  }
  .MuiPaper-root .MuiTableRow-root {
    height: 36px;
  }
  .MuiPaper-root .MuiTableRow-root .MuiTableCell-root {
    padding: 4px 0;
  }
  .cell-padding {
    padding-right: 8px;
  }
`;
